// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/","id":"1"},"2":{"path":"/wechat-auth/callback","id":"2"},"3":{"path":"/games/:projectId","id":"3"},"4":{"path":"/games/:projectId/play","id":"4"},"5":{"path":"/reports/:reportId/print","id":"5"},"6":{"path":"/reports/:reportId","id":"6"},"7":{"path":"/profile","id":"7"},"8":{"path":"/invites","id":"8"},"9":{"path":"/invites/:invitationId/live","id":"9"},"10":{"path":"/invites/:invitationId","id":"10"},"11":{"path":"/join","id":"11"}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import(/* webpackChunkName: "p__index" */'@/pages/index.tsx')),
'2': React.lazy(() => import(/* webpackChunkName: "p__wechat-auth__callback" */'@/pages/wechat-auth/callback.tsx')),
'3': React.lazy(() => import(/* webpackChunkName: "p__games__detail" */'@/pages/games/detail.tsx')),
'4': React.lazy(() => import(/* webpackChunkName: "p__games__play" */'@/pages/games/play.tsx')),
'5': React.lazy(() => import(/* webpackChunkName: "p__reports__print" */'@/pages/reports/print.tsx')),
'6': React.lazy(() => import(/* webpackChunkName: "p__reports__detail" */'@/pages/reports/detail.tsx')),
'7': React.lazy(() => import(/* webpackChunkName: "p__profile" */'@/pages/profile.tsx')),
'8': React.lazy(() => import(/* webpackChunkName: "p__invites" */'@/pages/invites.tsx')),
'9': React.lazy(() => import(/* webpackChunkName: "p__invites__live" */'@/pages/invites/live.tsx')),
'10': React.lazy(() => import(/* webpackChunkName: "p__invites__detail" */'@/pages/invites/detail.tsx')),
'11': React.lazy(() => import(/* webpackChunkName: "p__join" */'@/pages/join.tsx')),
},
  };
}
